module.exports = __webpack_public_path__ + "static/media/buddy-icon-red-cross.82afeb93.png";